import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-product-selection-tab',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './product-selection-tab.component.html',
})
export class ProductSelectionTabComponent {
    @Input() bankProductsTotal: number = 0;
    @Input() P2P_ProductsTotal: number = 0;
    @Input() DigitalBanks_ProductsTotal: number = 0;
    @Input() isP2POnly: boolean = false;
}
